<template>
  <div class="some">
    <div v-bind:class="[width === 'post' ? 'articleContainer' : '']">
      <h2>Jaa</h2>
      <img class="headingLine" :src="line" />
      <div class="icons">
        <a
          class="somelink"
          v-bind:href="fbUrl"
          target="_blank"
          aria-label="Jaa Facebookissa"
        >
          <div class="iconWrap">
            <img class="fbicon" v-bind:src="fbicon" alt="Facebook" />
          </div>
        </a>

        <a
          class="somelink"
          v-bind:href="twitterUrl"
          target="_blank"
          aria-label="Jaa Twitterissä"
        >
          <div class="iconWrap">
            <img class="twittericon" v-bind:src="twittericon" alt="Twitter" />
          </div>
        </a>

        <a
          class="somelink"
          v-bind:href="linkedinUrl"
          target="_blank"
          aria-label="Jaa LinkedInissä"
        >
          <div class="iconWrap">
            <img
              class="linkedinicon"
              v-bind:src="linkedinicon"
              alt="LinkedIn"
            />
          </div>
        </a>
        <a
          class="somelink"
          v-bind:href="shareUrl"
          aria-label="Jaa sähköpostilla"
        >
          <div class="iconWrap">
            <img class="mailicon" v-bind:src="emailicon" alt />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: window.location.href,
      title: document.title,
      fbUrl: "",
      twitterUrl: "",
      linkedinUrl: "",
      shareUrl: "",
    };
  },
  props: {
    fbicon: String,
    twittericon: String,
    linkedinicon: String,
    emailicon: String,
    line: String,
    width: String,
  },
  methods: {
    createUrls() {
      const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
      this.fbUrl = fbUrl;
      const twitterUrl = `https://twitter.com/intent/tweet?text=${this.url}`;
      this.twitterUrl = twitterUrl;
      const shareUrl = `mailto:?body=${this.title}%0D%0A%0D%0A${this.url}&subject=${this.title}`;
      this.shareUrl = shareUrl;
      const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}`;
      this.linkedinUrl = linkedinUrl;
    },
  },
  mounted() {
    this.createUrls();
  },
  updated() {},
};
</script>

<style scoped>
.some {
  padding: 20px;
}
.icons img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.headingLine {
  width: 100px;
  margin-bottom: 20px;
}
h2 {
  margin-bottom: 5px;
}
.somelink {
  width: 40px;
  height: 40px;
  background: #004267;
  border-radius: 45px;
  display: inline-block;
  position: relative;
}
.iconWrap {
  width: calc(100% -10px);
  height: calc(100% -10px);
  padding: 5px;
}
.articleContainer {
  width: 630px;
  margin: 0 auto;
}
</style>
